import { TableTotalLabel } from "../StyledComponents/TableHeaderStyledComponents"
import { StyledHeaderContainer, StyledTitleHeader } from "../StyledComponents/TableHeaderStyledComponents"
import { TableActionButtons } from "./TableActionButtons"

interface TableTitleHeaderProps {
    title: string
    actionButtons?: boolean
    onUpdatePaymentStatus?: () => void
    onBulkInvoiceDetails?: () => void
}

export const TableTitleHeader = ({
    title,
    actionButtons,
    onUpdatePaymentStatus,
    onBulkInvoiceDetails,
}: TableTitleHeaderProps) => {
    return (
        <StyledTitleHeader>
            <StyledHeaderContainer>
                <TableTotalLabel>{title}</TableTotalLabel>
                {actionButtons && (
                    <TableActionButtons
                        onUpdatePaymentStatus={onUpdatePaymentStatus}
                        onBulkInvoiceDetails={onBulkInvoiceDetails}
                    />
                )}
            </StyledHeaderContainer>
        </StyledTitleHeader>
    )
}
